import * as actionTypes from './actionTypes';
import type { Project } from './types';

/*------------------------------------------------------------------------------------------------*/
/* Projects Fetch Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/

export const fetchProjectsRequest = () => ({
  type: actionTypes.FETCH_PROJECTS_REQUEST,
});

export const fetchProjectsError = (error: string) => ({
  type: actionTypes.FETCH_PROJECTS_ERROR,
  error,
});

export const fetchProjectsResponse = (response: Project[]) => ({
  type: actionTypes.FETCH_PROJECTS_RESPONSE,
  response,
});

/*------------------------------------------------------------------------------------------------*/
/* Projects Update Actions                                                                         */
/*------------------------------------------------------------------------------------------------*/

export const updateProjectRequest = (project: Project) => ({
  type: actionTypes.UPDATE_PROJECT_REQUEST,
  project,
});

export const updateProjectError = (error: string) => ({
  type: actionTypes.UPDATE_PROJECT_ERROR,
  error,
});

export const updateProjectResponse = (response: Project) => ({
  type: actionTypes.UPDATE_PROJECT_RESPONSE,
  response,
});
